import React from 'react';

const Imagesec = () => {
    return (
        <div className='min-h-screen bg-fixed bg-[url("https://i0.wp.com/grandcanyonweddingpackages.com/wp-content/uploads/2018/12/Grand-Canyon-Wedding-Packages-Favorites-20187.jpg?resize=2000%2C1200&ssl=1")] bg-cover bg-no-repeat bg-center'>
            
        </div>
    );
};

export default Imagesec;